import React from 'react';
import { Loader2 } from 'lucide-react';

const Loader = ({ message = "Chargement...", fullScreen = false }) => {
  const containerStyle = fullScreen 
    ? { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', width: '100%', color: 'var(--text-secondary)', backgroundColor: 'var(--bg-color)', position: 'fixed', top: 0, left: 0, zIndex: 9999 }
    : { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '3rem', color: 'var(--text-secondary)', width: '100%' };

  return (
    <div style={containerStyle}>
      <style>{`
        @keyframes spin-slow {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .loader-spin {
          animation: spin-slow 1.5s linear infinite;
          color: var(--primary-color);
          margin-bottom: 1.5rem;
        }
      `}</style>
      
      <Loader2 size={fullScreen ? 56 : 40} className="loader-spin" />
      
      <div style={{ fontSize: '1.1rem', fontWeight: '500', animation: 'pulse 2s infinite', textAlign: 'center', padding: '0 1.5rem', lineHeight: '1.4' }}>{message}</div>
    </div>
  );
};

export default Loader;
